module.exports = __webpack_public_path__ + "726a1d627a1b3d697e896af505e0a499.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icons/Download.png
// module id = NPLI
// module chunks = 0